import { Component, HostBinding, Input, OnInit } from '@angular/core';

/**
 * This component can be used to show a simple loading message while some http call is in progress
 * The message will be center aligned by default
 */
@Component({
  selector: 'sp-loading-inprogress',
  templateUrl: './loading-inprogress.component.html',
  styles: [],
})
export class LoadingInprogressComponent implements OnInit {
  /**
   * Message to show while loading
   */
  @Input() message = 'loading...';

   /**
   * Size of spinner
   */
   @Input() diameter = 100;

  /**
   * Whether to show spinner or not
   * If spinner is visible, text will be hidden
   */
  @Input() showSpinner = false;

  /**
   * Included css classes to center align the text both vertically as well as horizontally
   */
  @HostBinding('className') classList = 'h-full w-full';

  /**
   * Any other classes that needs to be applied to the host element
   */
  @Input() class!: string;

  ngOnInit(): void {
    if (this.class) {
      // append css classes passed through input
      this.classList += ` ${this.class}`;
    }
  }

}
